export default function CheckersIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M8 8h16v16H8zM40 8h16v16H40zM24 24h16v16H24zM8 40h16v16H8zM40 40h16v16H40z" fill="#3B434F" />
      <circle cx="16" cy="48" r="7" fill="#2F8BFF" />
      <circle cx="48" cy="48" r="7" fill="#2F8BFF" />
      <circle cx="32" cy="32" r="7" fill="#FF8A1F" />
      <circle cx="48" cy="16" r="7" fill="#FF8A1F" />
      <path d="M11 45l3 2.5 2-4 2 4 3-2.5-1 7h-8z" fill="#E7ECF3" />
    </svg>
  );
}
